import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Store } from "../utils/storage";

const storage = Store("session");

// Define initial State
const State = {
  connectionError: false,
  satelliteView: false,
};

// Define actions
const Actions = (_set, get) => {
  const set = _set;
  // set connection error
  const setConnectionError = (error) => {
    set({ connectionError: error });
  };

  const toggleSatelliteView = () => {
    set({ satelliteView: !get().satelliteView });
  };

  return {
    setConnectionError,
    toggleSatelliteView,
  };
};

// Create Zustand store
const AppSettings = create(
  persist(
    (set, get) => {
      const actions = Actions(set, get);
      return {
        ...State,
        setConnectionError: actions.setConnectionError,
        toggleSatelliteView: actions.toggleSatelliteView,
      };
    },
    {
      name: "app.global",
      storage: createJSONStorage(() => storage),
    }
  )
);

export default AppSettings;
